import { ContainerStyleProps } from '@minecraft.atoms';
import { SubNavProps } from '../SubNav';

export enum LayoutType {
  Basic = 'basic',
  TwoColumn = 'two-column',
}

export type BaseLayoutProps<NavKey extends string> = {
  header?: React.ReactNode;
  bodyMaxWidth?: 'sm' | 'md' | 'lg' | 'full';
  pageBgColor?: ContainerStyleProps['bgColor'];
  subNavProps?: SubNavProps<NavKey>;
  children?: React.ReactNode;
  pageTitle?: string;
  'data-testid'?: string;
  gridHeightClass?: string;
};

export type BasicLayoutProps<NavKey extends string> = BaseLayoutProps<NavKey> & {
  children?: React.ReactNode;
  scrollRef?: React.RefObject<HTMLDivElement>;
};

export type TwoColumnLayoutProps<NavKey extends string> = BaseLayoutProps<NavKey> & {
  leftChildren?: React.ReactNode;
  rightChildren?: React.ReactNode;
};
